import type { EokoCustomer } from '@/types'
import LoadingBox from '@/components/loading-box'
import ErrorBox from '@/components/error-box'
import { useEokoCustomers } from '@/hooks/api/use-collection-company'

interface EokoCustomersLoaderProps {
    children: (data: Array<EokoCustomer> ) => React.ReactNode
    privateList?: boolean
}

const EokoCustomersLoader: React.FC<EokoCustomersLoaderProps> = ({
    children,
}) => {

    const { status, data, error } = useEokoCustomers()

    if (status === 'pending') {
        return <LoadingBox />
    }

    if (error) {
        return <ErrorBox
            error={error}
            message={'Nepovedlo se načíst zákazníky z EOKA'}
        />
    }


    if (data.length > 0) {
        return <>{children(data)}</>
    }

    return null
}

export default EokoCustomersLoader
